import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24')
];

export const server_loads = [0];

export const dictionary = {
		"/": [2],
		"/about-us": [~4],
		"/about": [3],
		"/checkout": [5],
		"/checkout/OrderConfirmation": [6],
		"/cookies": [7],
		"/corporate-orders-2": [~8],
		"/corporateOrders": [9],
		"/cupcakes": [~10],
		"/customCreations": [11],
		"/ireland-am": [~12],
		"/irelandAm": [~13],
		"/layer-cakes": [~14],
		"/media": [~15],
		"/online-shop-2": [~17],
		"/online-shop": [~16],
		"/pies": [~18],
		"/privacy": [19],
		"/products/[product]": [~20],
		"/shop": [~21],
		"/specialOccasions": [22],
		"/terms": [23],
		"/weddings": [~24]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';